/* eslint class-methods-use-this: 0 */

import { mixin } from 'lodash';
import CollectionApi from 'client/api/v2/CollectionApi';
import CollectionModule from 'store/modules/CollectionModule';
import ImportUsersMixin, { updateState } from 'client/store/mixins/ImportUsersMixin';

export class ImportUsersCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();

    mixin(module.actions, ImportUsersMixin.actions);
    mixin(module.getters, ImportUsersMixin.getters);
    mixin(module.mutations, ImportUsersMixin.mutations);

    module.actions.selectAllItems = (...params) => this.selectAllItems(...params);
    module.actions.unselectAllItems = (...params) => this.unselectAllItems(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------

  getInitialState() {
    return updateState(super.getInitialState());
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  /**
   * @description Provide the ability for the user to select all users in the list.
   */
  selectAllItems(context) {
    return new Promise((resolve) => {
      // this setTimeout wrapper fixes a bug with the loading spinner
      // not rendering when selecting all.
      setTimeout(() => {
        const { allUsers } = context.state.entities;
        const ids = Object.keys(allUsers.byId);
        const users = ids.map(user => allUsers.byId[user]);

        context.commit('SELECT_ALL_ITEMS', { ids });
        context.commit('ADD_BOUND_ITEMS', users);
        resolve();
      }, context.state.entities.items.totalCount / 2);
      // this timeout is dynamic based on the number of items in the vuex store
      // a larger dataset requires a larger timeout.
    });
  }

  /**
   * @description Provide the ability for the user to unselect all users in the list.
   * Since we've got all the users imported from the CSV file, just remove all of them
   * from the selected items list.
   */
  unselectAllItems(context) {
    return new Promise((resolve) => {
      // this setTimeout wrapper fixes a bug with the loading spinner
      // not rendering when unselecting all.
      setTimeout(() => {
        const { allUsers } = context.state.entities;
        const ids = Object.keys(allUsers.byId);
        context.commit('UNSELECT_ALL_ITEMS', { ids });
        context.commit('REMOVE_BOUND_ITEMS', { ids });
        resolve();
      }, context.state.entities.items.totalCount / 2);
      // this timeout is dynamic based on the number of items in the vuex store
      // a larger dataset requires a larger timeout.
    });
  }
}

export default new ImportUsersCollectionClass(CollectionApi, 'id', 'lastname').extractModule();
